import * as actionTypes from 'actions/actionTypes';
import initialState from 'config/initialMarketingConsentsState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MARKETING_CONSENTS: {
      const { consentToAppend } = action.data;
      if (consentToAppend) {
        const { consentName } = consentToAppend;
        if (!state.find((consent) => consent.consentName === consentName)) {
          return [
            ...state,
            consentToAppend,
          ];
        }
      }
      return state;
    }
    case actionTypes.GET_MARKETING_CONSENTS_SUCCESS: {
      const consentValues = action.result.data.reduce((result, consent) => ({
        ...result,
        [consent.consentName]: consent.value || false,
      }), {});
      return state.map((consent) => {
        let dependantConsents;
        if (consent.dependantConsents) {
          dependantConsents = consent.dependantConsents.map((dependantConsent) => ({
            consentName: dependantConsent.consentName,
            value: consentValues[dependantConsent.consentName],
          }));
        }
        return {
          ...consent,
          dependantConsents,
          value: consentValues[consent.consentName],
        };
      });
    }

    case actionTypes.PUT_CONSENTS: {
      const { data } = action;
      return state.map((consent) => ({
        ...consent,
        value: data[consent.consentName] || false,
      }));
    }

    default:
      return state;
  }
};

export default reducer;
